import { AfterViewChecked, booleanAttribute, ChangeDetectionStrategy, Component, computed, ElementRef, HostBinding, HostListener, inject, input, signal, untracked, viewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: '[trgButton]',
  templateUrl: './TrgButton.component.html',
  styleUrls: ['./TrgButton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
    exportAs: 'trgButton',
  host: {
    '[class.trg-btn]': 'true',
    '[class.trg-btn-disabled]': 'disabled()',
    '[class.trg-btn-round]': 'round()',
    '[attr.data-trg-btn-color]': 'color()',
    '[attr.aria-disabled]': 'disabled()',
    '[attr.tabindex]': 'disabled() ? -1 : 0',
    '[class.trg-btn-no-right]': 'trgBtnRightEmpty()',
    '[class.trg-btn-no-icon]': 'trgBtnIconEmpty()',
    '[class.trg-btn-no-text]': 'trgBtnTextEmpty()',
    '[class.trg-btn-center]': 'center()',
    '[title]': 'titleValue()',
  },
  standalone: false
})
export class TrgButtonComponent implements AfterViewChecked {
  readonly color = input<string>();
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly round = input(false, { transform: booleanAttribute });
  readonly center = input(false, { transform: booleanAttribute });
  readonly title = input<string>(null);
  readonly tooltip = input<any>(null);
  readonly titleValue = computed(() => this.tooltip() ?? this.title() ?? this.trgBtnText()?.nativeElement?.textContent ?? '');
 
  readonly element: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);

  readonly trgBtnRight = viewChild<ElementRef<HTMLDivElement>>('trgBtnRight');
  readonly trgBtnRightEmpty = signal(false);

  readonly trgBtnIcon = viewChild<ElementRef<HTMLDivElement>>('trgBtnIcon');
  readonly trgBtnIconEmpty = signal(false);

  readonly trgBtnText = viewChild<ElementRef<HTMLDivElement>>('trgBtnText');
  readonly trgBtnTextEmpty = signal(false);

  private _onclick: (this: GlobalEventHandlers, e: MouseEvent) => any;

  constructor() {
    this._onclick = this.element.nativeElement.onclick;
    this.element.nativeElement.onclick = e => {
      untracked(() => {
        if (this.disabled()) {
          e.stopImmediatePropagation();
          return;
        }
      });

      return this._onclick?.call(this, e);
    };
  }

  ngOnDestroy() {
  }

  @HostListener('click', ['$event'])
  onClick(e: MouseEvent) {
    if (this.disabled()) {
      e.stopImmediatePropagation();
      return false;
    }
  }

  ngAfterViewChecked() {
    this.trgBtnRightEmpty.set(!this.trgBtnRight()?.nativeElement?.childElementCount);
    this.trgBtnIconEmpty.set(!this.trgBtnIcon()?.nativeElement?.childElementCount);
    this.trgBtnTextEmpty.set(!this.trgBtnText()?.nativeElement?.childNodes.length);
  }
}
